import lodash from "lodash";
/**
 * Contains common utilities from lodash without actually depending on lodash.
 */
export var FakeLodash;
(function (FakeLodash) {
    function sum(arr) {
        return arr.reduce((a, b) => a + b, 0);
    }
    FakeLodash.sum = sum;
    function clamp(n, min, max) {
        return Math.min(Math.max(n, min), max);
    }
    FakeLodash.clamp = clamp;
    function minBy(collection, f) {
        if (collection.length == 0)
            return undefined;
        let min_score = f(collection[0]);
        let min_obj = collection[0];
        for (let i = 1; i < collection.length; i++) {
            const obj = collection[i];
            let score = f(obj);
            if (score < min_score) {
                min_score = score;
                min_obj = obj;
            }
        }
        return min_obj;
    }
    FakeLodash.minBy = minBy;
    function maxBy(collection, f) {
        return minBy(collection, e => -f(e));
    }
    FakeLodash.maxBy = maxBy;
    function sortBy(collection, f) {
        return [...collection].sort((a, b) => f(a) - f(b));
    }
    FakeLodash.sortBy = sortBy;
    function sortByComparator(collection, f) {
        return [...collection].sort(f);
    }
    FakeLodash.sortByComparator = sortByComparator;
    function sort(collection) {
        return sortBy(collection, identity);
    }
    FakeLodash.sort = sort;
    function identity(x) {
        return x;
    }
    FakeLodash.identity = identity;
    function sumBy(elements, f) {
        return sum(elements.map(f));
    }
    FakeLodash.sumBy = sumBy;
    function cloneDeep(value) {
        return lodash.cloneDeep(value);
    }
    FakeLodash.cloneDeep = cloneDeep;
})(FakeLodash || (FakeLodash = {}));
